import React from "react";

const CONTACT_MESSAGE = "Vid frågor, kontakta oss på följande adresser:";
const CONTACT_EMAILS = [
  "bjorn.johansson@empathy.nu",
  "hakan.johansson@empathy.nu",
];

const ContactUs: React.FC = () => {
  return (
    <div className="text-center text-white">
      <p className="text-lg font-nunito mt-2">{CONTACT_MESSAGE}</p>
      <ul className="mt-4 space-y-2 md:flex md:justify-center md:space-x-6 md:space-y-0">
        {CONTACT_EMAILS.map((email) => (
          <li key={email} className="text-lg font-nunito flex items-center">
            <span className="mr-2">•</span>
            {email}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ContactUs;
